import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-mastered-count-widget',
  templateUrl: './mastered-count-widget.component.html',
  styleUrls: ['./mastered-count-widget.component.scss'],
  standalone: false
})
export class MasteredCountWidgetComponent {

  @Input() showButtonToSmartRepetition: boolean = false;
  @Output() totalCardsCountChange: EventEmitter<number> = new EventEmitter<number>();

  cardsMasteredCount: number | undefined;
  totalCardsCount: number | undefined;

  constructor(
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.userService.getMasteredCardsCount().subscribe((res: any) => {
      this.cardsMasteredCount = res.cardsMasteredCount;
      this.totalCardsCount = res.totalCardsCount;

      this.totalCardsCountChange.emit(this.totalCardsCount);
    });
  }

  goToSmartRepetition() {
    window.location.href = '/smart-repetition';
  }
}
